import { useEffect, useState } from 'react';
import type MultiSelectFilter from '@tajawal/web-flights-sdk/lib/stores/filter/base/multi-select-filter.store';
import { autorun } from 'mobx';

export function useStateOfMultiSelectFilter(store: MultiSelectFilter) {
  const [state, setState] = useState(getProps(store));

  useEffect(
    () =>
      autorun(() => {
        setState(getProps(store));
      }),
    [store] // we need to track the change in steps(inbound/outbound) filter store change
  );

  return state;
}

const getProps = (store: MultiSelectFilter) => ({
  state: store.state,
  isDirty: store.isDirty,
  reset: store.reset,
  toggle: store.toggle,
  params: store.params,
  isSelected: store.isSelected,
});
